var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownarrowdark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.974,
    height: 5.703,
    viewBox: "0 0 9.974 5.703",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-arrow-down",
    "data-name": "Icon ionic-ios-arrow-down",
    d: "M11.176,15.23l3.771-3.774a.71.71,0,0,1,1.007,0,.719.719,0,0,1,0,1.01l-4.273,4.276a.711.711,0,0,1-.983.021L6.4,12.468A.713.713,0,1,1,7.4,11.459Z",
    transform: "translate(-6.188 -11.246)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrowdark);
export default __webpack_public_path__ + "static/media/downarrowdark.9154aad5b5dafc96adc2945dcc3af674.svg";
export { ForwardRef as ReactComponent };